export default {"src":"/login-app/[GIT_HASH]/_next/static/media/graph_upstream.cb2ec0aa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};